export default __webpack_public_path__ + "static/media/firecamp&tent.a3381dbe.jpg";